import { Icon, IconButton, TableSortLabel } from "@mui/material";
import type { ComponentProps, ReactNode } from "react";
import SortArrow from "../../../assets/images/sort-arrow.svg";
import type { SortableField } from "./dashboardSortFields";

type SortOrder = "asc" | "desc";

const SortArrowIcon = (props: ComponentProps<typeof IconButton>) => (
  <IconButton {...props}>
    <Icon>
      <img src={SortArrow} alt="" />
    </Icon>
  </IconButton>
);

type Props = {
  field: SortableField;
  label: ReactNode;
  sortField?: string;
  sortOrder?: string;
  onSort: (field: SortableField) => void;
  nowrap?: boolean;
};

/**
 * Header label with a sort arrow that is only visible on the active column
 * (MUI fades the icon in on hover for the inactive ones).
 */
export default function SortableHeaderLabel({
  field,
  label,
  sortField,
  sortOrder,
  onSort,
  nowrap,
}: Props) {
  const active = sortField === field;
  const direction: SortOrder =
    active && (sortOrder === "asc" || sortOrder === "desc") ? sortOrder : "asc";

  return (
    <TableSortLabel
      sx={{ textWrap: nowrap ? "nowrap" : "wrap" }}
      active={active}
      direction={direction}
      onClick={() => onSort(field)}
      IconComponent={SortArrowIcon}
    >
      {label}
    </TableSortLabel>
  );
}
